<template>
  <div class="min-h-[60vh] flex items-center justify-center px-6">
    <div class="max-w-2xl w-full text-center">
      <h1 class="text-3xl md:text-4xl font-bold text-gray-900 mb-3">Page not found</h1>
      <p class="text-base md:text-lg text-gray-600">
        Please check you've used the correct link for your university page.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "RootNotFound",
};
</script>
